import { useEffect } from 'react';

/**
 * Hook que maneja los estilos de overflow para KambiSportsbook
 * Aplica overflow: hidden a html y body cuando el componente está montado
 * y los restaura cuando se desmonta
 */
export const useKambiScroll = () => {
  useEffect(() => {
    // Guardar los valores originales de overflow
    const originalHtmlOverflow = document.documentElement.style.overflow;
    const originalBodyOverflow = document.body.style.overflow;

    // Aplicar overflow: hidden cuando el componente se monta
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';

    // Cleanup: restaurar los valores originales cuando el componente se desmonta
    return () => {
      document.documentElement.style.overflow = originalHtmlOverflow || '';
      document.body.style.overflow = originalBodyOverflow || '';
    };
  }, []);
};
